import React, { useEffect, useState } from 'react';
import ShipmentList from '../components/shipment/ShipmentList';
import BookingForm from '../components/booking/BookingForm';
import { useLocation } from 'react-router-dom';
import BookingList from '@/components/booking/BookingList';

const Shipment = () => {
    const [view, setView] = useState('list');
    const [selectedShipment, setSelectedShipment] = useState(null);

    const location = useLocation();

    const handleCreateNew = () => {
        setSelectedShipment(null);
        setView('form');
    };

    const handleViewShipment = (shipment) => {
        setSelectedShipment(shipment);
        setView('form');
    };

    const handleBackToList = () => {
        setSelectedShipment(null);
        setView('list');
    };

    const bookingId = location?.state?.bookingId;

    useEffect(() => {
        if (bookingId) {
            setSelectedShipment(bookingId);
            setView('form');
        }
    }, [bookingId]);


    return (
        <div className="h-full p-4">
            {view === 'list' ? (
                <BookingList
                    onCreateNew={handleCreateNew}
                    onViewShipment={handleViewShipment}

                />
                
                
            ) : (
                <BookingForm
                    onBack={handleBackToList}
                    bookingData={selectedShipment}
                />
            )}
        </div>
    );
};

export default Shipment;
